import {
  cellRenderer,
  SandboxTableConfig,
  realmIdCellProps,
  teamNameCellProps,
  statusCellProps,
  createdCellProps,
  creatorCellProps,
  tagsCellProps,
  checkboxCellProps,
  realmsCellProps,
  tenantCellProps,
  formatActiveRealms,
  formatNonActiveRealms,
  archivedAtCellProps,
  archiverCellProps,
} from 'SandboxModule/components/sharedTableConfigs';
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import { RealmTableView } from 'RealmModule/constants/realm';

const tableConfigs = {
  [RealmTableView.Active]: {
    cellProps: {
      headCells: [
        checkboxCellProps,
        tenantCellProps,
        realmIdCellProps,
        teamNameCellProps,
        creatorCellProps,
        createdCellProps,
        tagsCellProps,
        realmsCellProps,
      ],
    },
    formatData: formatActiveRealms,
  },
  [RealmTableView.Archived]: {
    headerProps: {
      tableTitle: 'Archived Subscription',
    },
    cellProps: {
      headCells: [
        checkboxCellProps,
        tenantCellProps,
        realmIdCellProps,
        teamNameCellProps,
        statusCellProps,
        creatorCellProps,
        createdCellProps,
        archiverCellProps,
        archivedAtCellProps,
        tagsCellProps,
        realmsCellProps,
      ],
    },
    // Archived realms are selectable so a teardown that stalled at
    // "Partially Removed" can be retried from the UI. Row-level gating lives
    // in checkIsSandboxDestroyable (fully Removed rows stay disabled).
    shouldHideBulkActionSelector: false,
    formatData: formatNonActiveRealms,
  },
  shared: {
    cellProps: {
      cellRenderer,
      headCells: [],
    },
    headerProps: {
      tableTitle: 'Subscription',
    },
    paginationProps: {
      hidePagination: true,
    },
    shouldHideBulkActionSelector: false,
  },
};

export const getTableConfigs = ({ variant }: { variant: RealmTableView }): SandboxTableConfig => {
  const tableConfig = cloneDeep(tableConfigs[variant]);
  const sharedConfig = cloneDeep(tableConfigs.shared);

  return merge(sharedConfig, tableConfig);
};
